// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"Baa-z","sponsoredTooltipWrapper":"Caa-z","sponsoredTooltip":"Daa-z","newCard":"Eaa-z"};